module.exports = __webpack_public_path__ + "static/media/19_2.157ab33c.png";